export class DynamicDocumentUtils {
    public static readonly SIZE_SELECTOR: DisguiseDto.SelectDto[] = [{
        text: '',
        value: ''
    }, {
        text: '1 / 48',
        value: '1'
    }, {
        text: '2 / 48',
        value: '2'
    }, {
        text: '3 / 48',
        value: '3'
    }, {
        text: '4 / 48 - zwölftel',
        value: '4'
    }, {
        text: '5 / 48',
        value: '5'
    }, {
        text: '6 / 48 - achtel',
        value: '6'
    }, {
        text: '7 / 48',
        value: '7'
    }, {
        text: '8 / 48 - sechstel',
        value: '8'
    }, {
        text: '9 / 48',
        value: '9'
    }, {
        text: '10 / 48',
        value: '10'
    }, {
        text: '11 / 48',
        value: '11'
    }, {
        text: '12 / 48 - viertel',
        value: '12'
    }, {
        text: '13 / 48',
        value: '13'
    }, {
        text: '14 / 48',
        value: '14'
    }, {
        text: '15 / 48',
        value: '15'
    }, {
        text: '16 / 48 - drittel',
        value: '16'
    }, {
        text: '17 / 48',
        value: '17'
    }, {
        text: '18 / 48',
        value: '18'
    }, {
        text: '19 / 48',
        value: '19'
    }, {
        text: '20 / 48',
        value: '20'
    }, {
        text: '21 / 48',
        value: '21'
    }, {
        text: '22 / 48',
        value: '22'
    }, {
        text: '23 / 48',
        value: '23'
    }, {
        text: '24 / 48 - hälfte',
        value: '24'
    }, {
        text: '25 / 48',
        value: '25'
    }, {
        text: '26 / 48',
        value: '26'
    }, {
        text: '27 / 48',
        value: '27'
    }, {
        text: '28 / 48',
        value: '28'
    }, {
        text: '29 / 48',
        value: '29'
    }, {
        text: '30 / 48',
        value: '30'
    }, {
        text: '31 / 48',
        value: '31'
    }, {
        text: '32 / 48',
        value: '32'
    }, {
        text: '33 / 48',
        value: '33'
    }, {
        text: '34 / 48',
        value: '34'
    }, {
        text: '35 / 48',
        value: '35'
    }, {
        text: '36 / 48 - dreiviertel',
        value: '36'
    }, {
        text: '37 / 48',
        value: '37'
    }, {
        text: '38 / 48',
        value: '38'
    }, {
        text: '39 / 48',
        value: '39'
    }, {
        text: '40 / 48',
        value: '40'
    }, {
        text: '41 / 48',
        value: '41'
    }, {
        text: '42 / 48',
        value: '42'
    }, {
        text: '43 / 48',
        value: '43'
    }, {
        text: '44 / 48',
        value: '44'
    }, {
        text: '45 / 48',
        value: '45'
    }, {
        text: '46 / 48',
        value: '46'
    }, {
        text: '47 / 48',
        value: '47'
    }, {
        text: '48 / 48',
        value: '48'
    }];
}
